/** @module Apparel/Theme/ThemeMasterSubtypeForm */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Field",
	"csi/enums",
	"csi/form/Widget",
	"csi/xml"
], function(declare,lang,def,Field,enums,Widget,xml) {

	const THEME_BOM_FEATURE = "ThemeBOMFeature";
	const THEME_TO_SEASON = "ThemeToSeason";
	const ALLOW_MATERIAL_VARIATION_PER_COLORWAY = "AllowMaterialVariationPerColorway";
	const ALLOW_MULTIPLE_THEMES_PER_SEASON = "AllowMultipleThemesPerSeason";

	return declare(Widget, {

		_resolveView : function() {
			this.defView.addField(lang.mixin(new Field(), {
				m_id: THEME_TO_SEASON,
				m_path: "Child:SetupSettings",
				m_type: xml.ATTR_ENUM,
				m_typeControl: def.FIELD_FILTERING_SELECT
			}), 0);

			this.defView.addField(lang.mixin(new Field(), {
				m_id: THEME_BOM_FEATURE,
				m_path: "Child:SetupSettings",
				m_type: xml.ATTR_ENUM,
				m_typeControl: def.FIELD_FILTERING_SELECT
			}), 1);

			this.defView.addField(lang.mixin(new Field(), {
				m_id: ALLOW_MATERIAL_VARIATION_PER_COLORWAY,
				m_path: "Child:SetupSettings",
				m_typeControl: def.FIELD_CHECKBOX
			}), 2);

			this.defView.addField(lang.mixin(new Field(), {
				m_id: ALLOW_MULTIPLE_THEMES_PER_SEASON,
				m_path: "Child:SetupSettings",
				m_typeControl: def.FIELD_CHECKBOX
			}), 3);

			this.inherited(arguments);
		},

		/**
		 * Creates the store for the "ThemeToSeason" enum field
		 */
		getFieldStore: function(field, value) {
			if (field.m_name == THEME_TO_SEASON) {
				return enums.getStore(THEME_TO_SEASON, value);
			}
			if (field.m_name == THEME_BOM_FEATURE) {
				return enums.getStore(THEME_BOM_FEATURE, value);
			}
			else {
				return this.inherited(arguments);
			}
		}

	});
});